import { API_URL } from "../consts/ApiUrl";
import { useNavigate } from "react-router-dom";

export const postUser = async (
  idToken: string,
  bodyData: Record<string, string>,
  successPath: string,
  navigate: ReturnType<typeof useNavigate>
): Promise<void> => {
  try {
    const response: Response = await fetch(API_URL.USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authentication: idToken,
      },
      body: JSON.stringify(bodyData),
    });

    if (!response.ok) {
      if (response.status === 401) {
        navigate("/signin");
      } else {
        navigate("/error");
      }
      return;
    }

    navigate(successPath);
  } catch (error) {
    console.error("Error in postUser:", error);
    navigate("/error");
  }
};
